import { render, staticRenderFns } from "./MiddlePagesForm.vue?vue&type=template&id=3ba9cf76&"
import script from "./MiddlePagesForm.vue?vue&type=script&lang=js&"
export * from "./MiddlePagesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports